import {getProductOverview} from '@/services/ProductsService/ProductOverview/productOverview'
import {useQuery} from '@tanstack/react-query'
import {useParams} from 'react-router-dom'

export const useGetComboDetails = () => {
  const {id} = useParams()

  const query = useQuery({
    queryKey: ['COMBO_DETAIL', id],
    queryFn: () => getProductOverview(`${id}`),
    enabled: !!id,
  })

  return query
}
